export function removeChild(el, parentEl) {
  parentEl = parentEl || el.parentElement;
  if (parentEl) {
    parentEl.removeChild(el);
  }
}



// WEBPACK FOOTER //
// ./src/chart/util/element.js